<template>
    <header class="header">
        <div class="header__content">
            <!-- header logo -->
            <a href="index.html" class="header__logo">
                <img src="img/logo.svg" alt="">
            </a>
            <!-- end header logo -->

            <!-- header menu btn -->
            <button class="header__btn" type="button">
                <span></span>
                <span></span>
                <span></span>
            </button>
            <!-- end header menu btn -->
        </div>
    </header>
</template>

<script>


    import axios from "axios";

    export default {
        name: 'TheHeader',
        components: {},
        data() {
            return {
                sub_days: 0,
                name: "",
                image: "",
                search_posters: [],
                search_txt: "",
                show_login: true,
            }
        },
        created() {
        }, mounted() {
            var profile = localStorage.getItem("login_info");
            if (profile != null && profile != '') {
                this.show_login = false;
                this.get_user_data();
            }
        },
        watch: {
            'search_txt': function () {
                this.search_data()
            }
        },
        methods: {
            hideSearch() {
                var removeShow = document.querySelector(".navbar .search");
                removeShow.classList.remove("show");
            },
            go_to_login() {
                this.$router.push({path: '/login'})
              $('#user-navbar').removeClass("active");

            },
            go_to_packages() {
                this.$router.push({path: '/packages'})
                $('#user-navbar').removeClass("active");

            },
            go_to_favorite() {
                this.$router.push({path: '/favorite'})
                $('#user-navbar').removeClass("active");

            },
            go_to_movie(poster) {
                this.search_posters = []
                this.search_txt = ""
                this.$router.push({path: "/course/"+this.name_to_slug(poster.title)+"/" + poster.id})
            },
            logout() {
                localStorage.setItem("login_info", "")
                window.open("/", "_self")
                $(this.hash).toggleClass("active").focus();

            },
            get_user_data() {

            },
            login_config() {

// Drop User-Data

                $(".user").on("focusout", function () {
                    $(this).removeClass("active");
                });
            },
          open_close_user_data(){
            $('#user-navbar').toggleClass("active").focus();

          },
            search_data() {
                var self = this;

                if (this.search_txt.length <= 3) {
                    self.search_posters = []
                    return;
                }
                // var token = log_data.filter(x=>x.name == "token")[0].value;
                var url = "search/" + this.search_txt + "/8F5A5G3D9B86FA54IJRELA685855/";

                // formData.append('id', "1532");
                axios.get(url, {}).then(function (response) {

                    self.search_posters = response.data.posters
                    // $('.droptrigger-search, .drop-trigger, .drop-userdata, .icon-sidebar').click(function () {
                    //   return false;
                    // });

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }
</script>
